import request from '../utils/request'


export function modifyOrderProcess(orderProcess) {
    return request({
        url: '/api/order/process/modify',
        method: 'post',
        data: orderProcess
    })
}

export function deleteOrderProcess(processId) {
    return request({
        url: '/api/order/process/delete',
        method: 'delete',
        params: {
            process_id: processId
        }
    })
}

export function submitOrderProcessValue(processId, value, orderId) {
    return request({
        url: '/api/order/process/submit',
        method: 'post',
        data: {
            process_id: processId,
            value: value,
        }
    })
}